import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "builder-component-container" }

import BuilderRow, { Row } from '@/components/Builder/BuilderRow.vue'

type Props = {
  rows: Row[]
}

export type { Row }

export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderComponent',
  props: {
    rows: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
      return (_openBlock(), _createBlock(BuilderRow, _mergeProps({
        key: i,
        row: row
      }, { ref_for: true }, _ctx.$attrs), null, 16, ["row"]))
    }), 128))
  ]))
}
}

})